import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { setRem } from './utils/rem'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

setRem()
window.addEventListener('resize', setRem)

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
